import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import _ from 'lodash'
import { messageActions } from '../../store/message'

const BASE_PATH = '/lottustech/bandeiras'
const crud = build(validate, BASE_PATH)
const prefix = 'crudBandeira'

const actions = new Action(prefix, crud)
const newTypes = {
  RESET: `${prefix}reset`,
  ADD_TAXA: `${prefix}addTaxa`,
  SET_TAXA: `${prefix}setTaxa`,
  ON_CLICK_REMOVE_TAXA: `${prefix}onClickRemoveTaxa`,
}

const types = Object.assign({}, actions.types, newTypes)

actions.reset = () => {
  return {
    type: types.RESET,
  }
}

actions.addTaxa = (payload) => {
  return {
    type: types.ADD_TAXA,
    payload,
  }
}

actions.setTaxa = (prop, value) => {
  return {
    type: types.SET_TAXA,
    prop,
    value,
  }
}

actions.onClickRemoveTaxa = (payload) => {
  return {
    type: types.ON_CLICK_REMOVE_TAXA,
    payload,
  }
}

actions.showWarningMessage = (message) => {
  return (dispatch, getState) => {
    dispatch(messageActions.messageShowMessages(makeMessages([message], 'warn')))
  }
}

const makeMessages = (messages, type) => {
  return messages.map((message) => {
    return {
      sticky: type === 'error',
      severity: type,
      detail: message,
    }
  })
}

export { types, actions }
